import { render, staticRenderFns } from "./Changes.vue?vue&type=template&id=f2bfb548"
import script from "./Changes.vue?vue&type=script&lang=js"
export * from "./Changes.vue?vue&type=script&lang=js"
import style0 from "./Changes.vue?vue&type=style&index=0&id=f2bfb548&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports